<template>
  <PageHeader
    title="Telephony"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  >
    <template v-if="tabs.length > 1" #bottom>
      <Page_Tabs
        class="px-6"
        :tabs="tabs"
        :initial-tab="activeTab"
        no-border
        @select="selectTab"
      />
    </template>
  </PageHeader>

  <div class="p-4">
    <div class="bg-white rounded-lg border border-gray-200">
      <TelephonyPhoneNumbers_Admin v-if="activeTab === 'phone_numbers'" />
      <TelephonyCallTypes_Admin v-else-if="activeTab === 'call_types'" />
      <TelephonyParticipantRoles_Admin v-else-if="activeTab === 'participant_roles'" />
      <TelephonyPhoneBook_Admin v-else-if="activeTab === 'phone_book'" />
      <p v-else class="p-6 text-sm text-gray-500">You do not have access to any telephony settings.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue'
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue'
import TelephonyPhoneNumbers_Admin from './TelephonyPhoneNumbers_Admin.vue'
import TelephonyPhoneBook_Admin from './TelephonyPhoneBook_Admin.vue'
import TelephonyCallTypes_Admin from './TelephonyCallTypes_Admin.vue'
import TelephonyParticipantRoles_Admin from './TelephonyParticipantRoles_Admin.vue'
import { FEATURES } from '@/constants/features'
import { canAccessFeature } from '@/utils/access'

const TAB_ROUTES = {
  phone_numbers: 'AdminTelephonyPhoneNumbers',
  call_types: 'AdminTelephonyCallTypes',
  participant_roles: 'AdminTelephonyParticipantRoles',
  phone_book: 'AdminTelephonyPhoneBook',
}

export default {
  name: 'Telephony_Admin',

  components: {
    PageHeader,
    Page_Tabs,
    TelephonyPhoneNumbers_Admin,
    TelephonyPhoneBook_Admin,
    TelephonyCallTypes_Admin,
    TelephonyParticipantRoles_Admin,
  },

  computed: {
    ...mapGetters('auth', ['current_user']),

    showPhoneNumbers() {
      return import.meta.env.VITE_ENV === 'sandbox' || this.current_user?.is_superuser
    },

    showPhoneBook() {
      return canAccessFeature(FEATURES.COMPONENT_TELEHEALTH_PHONE)
    },

    tabs() {
      const tabs = []
      if (this.showPhoneBook) tabs.push({ id: 'phone_book', label: 'Phone Book', icon: ['fas', 'address-book'], description: 'Named contacts that providers can call' })
      if (this.showPhoneBook) tabs.push({ id: 'call_types', label: 'Call Types', icon: ['fas', 'tags'], description: 'Types of calls care managers can log' })
      if (this.showPhoneBook) tabs.push({ id: 'participant_roles', label: 'Participant Roles', icon: ['fas', 'users'], description: 'Roles assigned to participants' })
      if (this.showPhoneNumbers) tabs.push({ id: 'phone_numbers', label: 'Phone Numbers', icon: ['fas', 'phone'], description: 'Tenant phone number inventory and assignments' })
      return tabs
    },

    activeTab() {
      const requested = this.$route.meta.telephonyTab
      if (this.tabs.some((tab) => tab.id === requested)) return requested
      return this.tabs[0]?.id || null
    },
  },

  methods: {
    selectTab(tabId) {
      if (tabId === this.activeTab) return
      this.$router.push({ name: TAB_ROUTES[tabId] })
    },
  },
}
</script>
